import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "00shot-cart";
const keyOf = (i) => `${i.ref_id}:${i.size || ""}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => localStorage.setItem(KEY, JSON.stringify(items)), [items]);

  const add = (item) =>
    setItems((cur) => {
      const found = cur.find((c) => keyOf(c) === keyOf(item));
      if (found) return cur.map((c) => (c === found ? { ...c, quantity: Math.min(100, c.quantity + item.quantity) } : c));
      return [...cur, item];
    });
  const setQty = (item, q) =>
    setItems((cur) => (q <= 0 ? cur.filter((c) => c !== item) : cur.map((c) => (c === item ? { ...c, quantity: Math.min(100, q) } : c))));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.quantity * i.price, 0);

  return <CartCtx.Provider value={{ items, add, setQty, clear, count, total, open, setOpen }}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
